"use client";

import { useState } from "react";
import { useTranslations } from "use-intl";

import { SearchIcon } from "@/components/appIcons";
import { useNavigateWithTopLoader } from "@/hooks/use-navigate-with-top-loader";
import { trackCatalogSearchSubmitted } from "@/lib/analytics";
import { normalizeSearchQuery } from "@/lib/normalize-search-query";

interface SearchInputProps {
  className?: string;
  autoFocus?: boolean;
  trackingSurface?: string;
}

export function SearchInput({
  className,
  autoFocus,
  trackingSurface = "search",
}: SearchInputProps) {
  const th = useTranslations("globals.header");
  const navigateWithTopLoader = useNavigateWithTopLoader();
  const [query, setQuery] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedQuery = normalizeSearchQuery(query);
    trackCatalogSearchSubmitted(trackingSurface);
    if (trimmedQuery) {
      navigateWithTopLoader({ to: "/search", search: { q: trimmedQuery } });
      return;
    }
    navigateWithTopLoader({ to: "/search" });
  };

  return (
    <div className={className ? `relative ${className}` : "relative"}>
      <form onSubmit={handleSubmit} className="flex h-11 w-full flex-col">
        <div className="flex h-full w-full flex-1 items-stretch rounded-lg bg-secondary">
          <div className="flex items-center justify-center pl-4 text-muted-foreground">
            <SearchIcon />
          </div>
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={th("searchPlaceholder")}
            autoFocus={autoFocus}
            className="flex w-full min-w-0 flex-1 border-none bg-transparent px-4 text-base font-normal placeholder:text-muted-foreground focus:outline-none focus:ring-0"
          />
        </div>
      </form>
    </div>
  );
}
